import React from "react";
import Styles from "./multipurposeCard.module.scss";
import EnhancedButton from "../../../(common)/EnhancedButton";

interface CommonCardProps {
  icon: React.ReactNode;
  title: string;
  value: string | number | React.ReactNode;
  buttonText: string;
  buttonId: string;
  buttonTo: string;
  ref?: any;
}

function CommonCard({
  icon,
  title,
  value,
  buttonText,
  buttonId,
  buttonTo,
  ref,
}: CommonCardProps) {
  return (
    <div className={`${Styles.card} ml-1 mb-2 mr-1 p-4`}>
      <div className="d-flex flex-column h-100">
        <div className={Styles.cardContent}>
          <div className="mb-3">
            <div className="d-flex justify-content-between mb-2">{icon}</div>
            <p className={Styles.cardTitle}>{title}</p>
            <p
              ref={ref}
              className={
                typeof value === "string"
                  ? Styles.boldTitle
                  : Styles.boldTitleLong
              }
            >
              {value}
            </p>
          </div>
        </div>
        <EnhancedButton
          title={buttonText}
          id={buttonId}
          to={buttonTo}
          size="sm"
          variant="outline-dark"
        />
      </div>
    </div>
  );
}

export default CommonCard;
